import {connect} from "react-redux";
import ExternalMomListing from "./List";
import {bindActionCreators} from "redux";
import {externalMomListRequest} from "../../service/Valet/action";
import {fetchAssignee} from "../../service/Assignment/action";

const mapStateToProps = (state) => ({
    externalMomListResponse:state.Valet.externalMomListResponse,
    getAssignee:state.AssignmentReducer.getAssignee,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            externalMomListRequest,
            fetchAssignee
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ExternalMomListing);
